<template>
	<v-dialog
		id="verification-dialog"
		v-model="dialog"
		max-width="420px"
		persistent
	>
		<v-card :style="fontStyle" class="text-center">
			<v-card-title class="justify-center">
				{{ dialogTitle }}
			</v-card-title>

			<v-card-text class="text-center">
				<p>{{ dialogBody }}</p>

				<v-text-field
					v-model="code"
					class="mb-3"
					outlined
					dense
					hide-details
					solo
					flat
					maxlength="6"
				/>
				<v-btn
					color="success"
					block
					@click="submit"
					:disabled="!readyToSubmit"
				>
					{{ $t("submit") }}
				</v-btn>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import fontMixin from "@/mixins/fontMixin.js";

export default {
	name: "VerificationCodeDialog",
	events: ["codeSubmit"],
	data() {
		return {
			dialog: false,
			receiver: null,
			code: "",
		};
	},
	methods: {
		open(receiver) {
			this.dialog = true;
			this.receiver = receiver;
			this.code = "";
		},
		submit() {
			this.dialog = false;
			this.$emit("code-submit", this.code);
		},
	},
	computed: {
		readyToSubmit() {
			return this.code.length === 6;
		},
		dialogTitle() {
			if (this.useFullCircleDataDialogText)
				return "User already registered";

			return this.$t("form.verification.enter");
		},
		dialogBody() {
			if (this.useFullCircleDataDialogText)
				return `Enter the verification code sent to ${this.receiver}`;

			return this.$t("form.verification.sent-to", {
				receiver: this.receiver,
			});
		},
		useFullCircleDataDialogText() {
			return this.$store.getters.settings.customFeatures
				.circleDataValidationDialogText;
		},
	},
	mixins: [fontMixin],
};
</script>
